module.exports = __webpack_public_path__ + "static/media/logo-dark.234b1890.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-dark.png
// module id = 416
// module chunks = 33